import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * The title block at the top of every page.
 *
 * Declared once so that page titles cannot drift in size, weight or spacing,
 * and so actions stack under the title on a phone instead of squeezing the
 * heading into two characters per line.
 */
export const PageHeader: React.FC<{
  title: string;
  subtitle?: string;
  /** Buttons or controls. Wrap to their own row below `sm`. */
  actions?: React.ReactNode;
}> = ({ title, subtitle, actions }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    spacing={2}
    sx={{
      mb: { xs: 2.5, md: 3 },
      alignItems: { xs: 'stretch', sm: 'flex-end' },
      justifyContent: 'space-between',
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', md: '2rem' } }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && (
      <Stack
        direction="row"
        spacing={1}
        sx={{ flexShrink: 0, flexWrap: 'wrap', gap: 1 }}
      >
        {actions}
      </Stack>
    )}
  </Stack>
);
